import React, { FC } from 'react';
import { SearchBar, SearchBarProps } from '../../../../../../common/main/searchbar/SearchBar';

export const StudentSearchBar: FC<SearchBarProps> = ({ onFilterTextChange }) => {
  return <SearchBar onFilterTextChange={onFilterTextChange} placeholder={'Поиск по ФИО студента, номеру ИСУ'} />;
};
